module.exports = __webpack_public_path__ + "static/media/angle-double-left.59923c03.svg";